import fx from 'money'
import numeral from 'numeral'

export default {
  data: () => ({
    currencyCode: {
      1: 'USD',
      2: 'YEN',
      3: 'EUR',
      4: 'GBP'
    }
  }),
  methods: {
    initExchangeRate () {
      fx.rates = {
        EUR: 0.89,
        GBP: 0.77,
        USD: 1,
        YEN: 106.75
      }

      fx.base = 'USD'
    },
    formatNumber (amount, format = '0,0') {
      if (Array.isArray(amount)) {
        const values = amount.map(value => this.formatNumber(value))

        return values.join(' — ')
      }

      const converted = fx.convert(amount, { from: 'USD', to: this.currencyCode[this.model.currency] })
      let prefix = '$'

      switch (this.currencyCode[this.model.currency]) {
        case 'USD':
          prefix = '$'
          break
        case 'GBP':
          prefix = '£'
          break
        case 'EUR':
          prefix = '€'
          break
        case 'YEN':
          prefix = '¥‎'
          break
      }

      return prefix + numeral(converted).format(format)
    }
  }
}
